import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import type { Flavor } from "@/types/flavor";

interface AppState {
  currentFlavor: Flavor;
  currentTenant: string | null;
  isInitialized: boolean;
  setFlavor: (flavor: Flavor) => void;
  setTenant: (tenant: string | null) => void;
  setInitialized: (initialized: boolean) => void;
}

export const useAppStore = create<AppState>()(
  devtools(
    persist(
      (set) => ({
        currentFlavor: (import.meta.env.VITE_FLAVOR as Flavor) || "beirut",
        currentTenant: null,
        isInitialized: false,
        setFlavor: (flavor) => set({ currentFlavor: flavor }),
        setTenant: (tenant) => set({ currentTenant: tenant }),
        setInitialized: (initialized) => set({ isInitialized: initialized }),
      }),
      {
        name: "app-storage",
        partialize: (state) => ({
          currentFlavor: state.currentFlavor,
          currentTenant: state.currentTenant,
        }),
      }
    ),
    { name: "AppStore" }
  )
);
